module.exports = __webpack_public_path__ + "media/photo/AdobeStock_315860783_UPDATE-3672c4ff.jpg";